const ss = require("@/services/socket");
const store = require("@/store").default;
const {customLogger} = require("@/utils");

onBoxQcmResult = async (data) => {
    return new Promise((resolve, reject) => {
        
        // handle error
        if (data.score === undefined || !data.step || !data.numberOfQuestions) {
            reject(new Error("Invalid data"));
            return;
        }
        ss.socket.emit("qcmEnd", data, (res) => {
            if (res && res.error) {
                reject(new Error(res.error));
            } else {
                customLogger("onBoxQcmResult callback", res);
                resolve(res); // Resolve with the response
            }
        });
    });
};

module.exports = {
    onBoxQcmResult,
};
